'use strict';

/** @type {import('./max')} */
module.exports = Math.max;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/max.js
// module id = 615
// module chunks = 0